import { render, staticRenderFns } from "./ProfilingQuestion.vue?vue&type=template&id=00f8ef58&scoped=true"
import script from "./ProfilingQuestion.vue?vue&type=script&lang=js"
export * from "./ProfilingQuestion.vue?vue&type=script&lang=js"
import style0 from "./ProfilingQuestion.vue?vue&type=style&index=0&id=00f8ef58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f8ef58",
  null
  
)

export default component.exports